import BaseModel from '../core/BaseModel'
export default class FormFieldModel extends BaseModel {
    constructor() {
        super({ 
                name: "form_field",
                tableName: 'core_form_field'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Tên trường dữ liệu',
                filter: { type: 'input',match: 'custom'},
                sortable: true,
                computed: (data) => {
                    data.name = (data.fields != undefined && data.fields != null && data.fields.name != undefined) ? data.fields.name : '';
                },
                width: 15
            },
            
            controlType: {
                name: 'controlType', label: 'Control Type', type: "Selection", class: 'left',  dataType: 'Label', dataDisplay: 'name',  width: 10, disabled: true,
                options: [{name: 'Text Field', value: 'text'}, {name: 'Text Area', value: 'textarea'}, {name: 'Number Field', value: 'number'}, {name: 'Date Picker', value: 'date'}],
                filter: { type: 'select',  display: false, optionLabel: 'name', optionKey: 'value', match: 'equals' },
                sortable: true,
                computed: (data) => {
                    data.controlType = (data.fields != undefined && data.fields != null && data.fields.frontend_type != undefined) ? data.fields.frontend_type : '';
                }
            },

            dataType: {
                name: 'dataType', label: 'Kiểu dữ liệu', type: "Selection", class: 'left',  dataType: 'Label', dataDisplay: 'name', width: 10, disabled: true,
                options: [{name: 'String', value: 'text'}, {name: 'Number', value: 'integer'}, {name: 'Decimal', value: 'float'}, {name: 'Date', value: 'date'}],
                filter: { type: 'select',  display: false, optionLabel: 'name', optionKey: 'value', match: 'equals' },
                sortable: true,
                computed: (data) => {
                    data.dataType = (data.fields != undefined && data.fields != null && data.fields.backend_type != undefined) ? data.fields.backend_type  : '';
                }
            },

            is_required: {
                name: 'is_required', label: 'Bắt buộc nhập', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 10, disabled: true,
                options: [{ value: true, label: 'Có'}, { value: false, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            is_display: {
                name: 'is_display', label: 'Hiển thị giao diện', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 10, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            ordering: { 
                name: 'ordering', 
                type: "String", 
                label: 'Thứ tự hiển thị',
                class: 'center',
                sortable: true,
                width: 10
            },
            form_id: {
                refs: ' fields { id name alias frontend_type backend_type} field_id',
                display: false
            }
        },)
    }

}